import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: 'app-session-warning-dialog',
  templateUrl: './session-warning-dialog.component.html',
  styleUrls: ['./session-warning-dialog.component.scss']
})
export class SessionWarningDialogComponent implements OnInit {
  title: string;
  dialogForm: FormGroup;
  private subscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<SessionWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SessionWarningDialogModel,
    private fb: FormBuilder
  ) {
    // Update view with given values
    this.title = data.title;
  }

  ngOnInit(): void {
    this.dialogForm = this.fb.group({});
  }

  onContinue(): void {
    // Close the dialog, return true
    if (this.dialogForm.valid) {
      this.dialogRef.close('continue');
    }
  }

  onLogout(): void {
    this.dialogRef.close('logout');
  }
}

export class SessionWarningDialogModel {
  constructor(public title: string, public warningMessage$: Observable<string>) { }
}